export default __webpack_public_path__ + "static/media/bgProgramm.5a1d1475.svg";